import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function PrevIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 17 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.65685 15.0709L0.292893 8.70691C-0.0976308 8.31639 -0.0976308 7.68322 0.292893 7.2927L6.65686 0.92874C7.04738 0.538215 7.68055 0.538215 8.07107 0.92874C8.46159 1.31926 8.46159 1.95243 8.07107 2.34295L3.41421 6.99981L16 6.99981C16.5523 6.99981 17 7.44752 17 7.99981C17 8.55209 16.5523 8.99981 16 8.99981L3.41421 8.99981L8.07107 13.6567C8.46159 14.0472 8.46159 14.6804 8.07107 15.0709C7.68054 15.4614 7.04738 15.4614 6.65685 15.0709Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
